
import { motion } from "framer-motion";
import { brandColors as colors } from "@/lib/palette";

export default function ThreadDecoration({
  className = "",
}: {
  className?: string;
}) {
  return (
    <svg className={className} viewBox="0 0 200 20" fill="none">
      <motion.path
        d="M0 10 Q25 2, 50 10 T100 10 T150 10 T200 10"
        stroke={colors.tan}
        strokeWidth="2"
        strokeLinecap="round"
        strokeDasharray="6 4"
        fill="none"
        initial={{ pathLength: 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration: 1.5, delay: 0.5 }}
      />
    </svg>
  );
}
